import * as Yup from "yup";

// componsation des soldes
export const QUERY_KEYS = "leave_compensate_soldes";
export const DEFAULT_HOURS_VALUE = "--,---";

export const BREADCRUMB_LEAVE = [
    {
        label: "Accueil",
        href: "/",
    },
    {
        label: "Gestionnaire des absences",
        href: "/leave",
    },
];

export const MINIMUM_DATE = (min) => {
    min ? console.log({ min }) : console.log("no min");
};

export const SCHEMA = Yup.object().shape({
    LeaveType: Yup.object()
        .nullable()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire"),
    start_date: Yup.date()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire")
        .test("year", "L'année doit être valide.", (value) => {
            const year = value?.getFullYear();
            return year > 2020;
        })
        .test(
            "start_date_before_end_date",
            "La date de début doit être avant la date de fin",
            function (value) {
                const { end_date } = this.parent;
                if (end_date instanceof Date && !isNaN(end_date)) {
                    return value instanceof Date && !isNaN(value)
                        ? value <= end_date
                        : true;
                }
                return true;
            }
        ),
    end_date: Yup.date()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire")
        .test("year", "L'année doit être valide.", (value) => {
            const year = value?.getFullYear();
            return year > 2020;
        })
        .test(
            "end_date_after_start_date",
            "La date de fin doit être après la date de début",
            function (value) {
                const { start_date } = this.parent;
                return !start_date || !value || value >= start_date;
            }
        ),
    negative_balance_alert_accepted: Yup.boolean().when("LeaveType", {
        is: (value) => {
            return value?.allow_negative_balance === true;
        },
        then: Yup.boolean()
            .transform((value, originalValue) => {
                if (!value)
                    return new Yup.ValidationError("Ce champ est obligatoire");
                return value;
            })
            .required(
                "Le champ otherField est obligatoire quand myBooleanField est vrai"
            ),
        otherwise: Yup.boolean(),
    }),
});

export const SCHEMARH = Yup.object({
    LeaveType: Yup.object()
        .nullable()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire"),
    start_date: Yup.date()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire")
        .test("year", "L'année doit être valide.", (value) => {
            const year = value?.getFullYear();
            return year > 2020;
        })
        .test(
            "start_date_before_end_date",
            "La date de début doit être avant la date de fin",
            function (value) {
                const { end_date } = this.parent;
                if (end_date instanceof Date && !isNaN(end_date)) {
                    return value instanceof Date && !isNaN(value)
                        ? value <= end_date
                        : true;
                }
                return true;
            }
        ),
    end_date: Yup.date()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire")
        .test("year", "L'année doit être valide.", (value) => {
            const year = value?.getFullYear();
            return year > 2020;
        })
        .test(
            "end_date_after_start_date",
            "La date de fin doit être après la date de début",
            function (value) {
                const { start_date } = this.parent;
                return !start_date || !value || value >= start_date;
            }
        ),
});

export const FILE_SIZE_LIMIT = 2_500_000;

export const I18N_NS_LEAVE = "leave";
